import { UserSetAvailabilityStatus } from '@api/generated/graphql';
import { logWorkspace, requireUser, updateUserStatus } from '../..';
import * as Telecom from '@servicetitan/telecom-rtcs-client';
import { userStatsFromAgentStats } from '../../types/ServiceUser';

async function handleAgentAway(event: Telecom.AgentAwayEvent) {
  const user = await requireUser(event.agentId);
  logWorkspace('service:agent:away:' + user?.name, event);

  // set the user status as away
  updateUserStatus(
    user.id,
    awayReasonToStatus(event.awayReason),
    getCanChangeStatus(event.awayReason),
  );

  user.available = event.available;
  user.stats = userStatsFromAgentStats(event.stats);

  // override to current time to workaround Kazoo issue
  user.stats.lastActionAt = new Date().toISOString();
}

function awayReasonToStatus(awayReason: string): UserSetAvailabilityStatus {
  switch (awayReason.toLowerCase()) {
    case 'available':
      return UserSetAvailabilityStatus.Available;
    case 'away from desk':
    case 'away_from_desk':
      return UserSetAvailabilityStatus.AwayFromDesk;
    case 'break':
      return UserSetAvailabilityStatus.Break;
    case 'unavailable':
    case 'force_away':
      return UserSetAvailabilityStatus.Unavailable;
    case 'wrap up':
    case 'extended wrap up':
    case 'extended_wrap_up':
    case 'wrap_up':
      return UserSetAvailabilityStatus.ExtendedWrapUp;
    case 'offline':
      return UserSetAvailabilityStatus.Offline;
    default:
      throw new Error(`Unknown away reason: ${awayReason}`);
  }
}

function getCanChangeStatus(awayReason: string): boolean {
  if (awayReason.toLowerCase().includes('call')) {
    return false;
  }
  return true;
}

export default handleAgentAway;
